import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import App from './App'
import { store } from './store'
import './index.css'
import 'react-vant/lib/index.css'
// 品牌主题覆盖：必须放在 react-vant 样式之后（弹窗走 Portal 挂到 body，
// 写在 :root 上才能让 Dialog/Popup 也拿到墨绿品牌色，详见 src/theme/brand.css）
import './theme/brand.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
)
